import { Users, TrendingUp, ShoppingCart, Search, Package, Image, MousePointerClick, Activity, BarChart2, ImageIcon } from "lucide-react";

export default function DashboardStats({ summary, onNavigate }) {
  const row1 = [
    {
      title: "Unique Visitors",
      value: summary?.total_unique_visitors,
      icon: Users,
      theme: "blue",
      tab: "visitors",
    },
    {
      title: "Total Visits",
      value: summary?.total_sessions,
      icon: TrendingUp,
      theme: "purple",
      tab: "visitors",
    }
  ];

  const row2 = [
    {
      title: "Query Searches",
      value: summary?.total_query_searches,
      icon: Search,
      theme: "indigo",
      tab: "query-searches",
    },
    {
      title: "Product Clicks",
      value: summary?.total_product_clicks,
      icon: Package,
      theme: "rose",
      tab: "product-clicks",
    },
    {
      title: "Buy Clicks",
      value: summary?.total_buy_clicks,
      icon: ShoppingCart,
      theme: "green",
      tab: "buy-clicks",
    }
  ];

  const row3 = [
    {
      title: "Image Searches",
      value: summary?.total_image_searches,
      icon: Image,
      theme: "fuchsia",
      tab: "image-searches",
    },
    {
      title: "Image Search Buy Clicks",
      value: summary?.total_image_search_buy_clicks,
      icon: MousePointerClick,
      theme: "pink",
      tab: "image-searches",
    }
  ];

  const getThemeClasses = (theme) => {
    switch (theme) {
      case "blue": return "bg-blue-50 text-blue-600 ring-1 ring-blue-500/20";
      case "purple": return "bg-purple-50 text-purple-600 ring-1 ring-purple-500/20";
      case "green": return "bg-green-50 text-green-600 ring-1 ring-green-500/20";
      case "indigo": return "bg-indigo-50 text-indigo-600 ring-1 ring-indigo-500/20";
      case "rose": return "bg-rose-50 text-rose-600 ring-1 ring-rose-500/20";
      case "fuchsia": return "bg-fuchsia-50 text-fuchsia-600 ring-1 ring-fuchsia-500/20";
      case "pink": return "bg-pink-50 text-pink-600 ring-1 ring-pink-500/20";
      default: return "bg-gray-50 text-gray-600 ring-1 ring-gray-500/20";
    }
  };

  const StatCard = ({ title, value, icon: Icon, theme, tab }) => (
    <div
      key={title}
      onClick={() => tab && onNavigate && onNavigate(tab)}
      className={`bg-white rounded-2xl shadow-sm border border-gray-100 p-4 flex flex-col justify-between transition-all duration-300 relative overflow-hidden group ${tab ? 'cursor-pointer hover:shadow-lg transform hover:-translate-y-1' : ''}`}
    >
      <div className={`absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-30 blur-3xl transition-transform duration-700 group-hover:scale-150 ${getThemeClasses(theme).split(' ')[0]}`}></div>
      <div className="flex items-center mb-2 relative z-10">
        <div className={`p-2 rounded-xl mr-3 ${getThemeClasses(theme)} shadow-sm transition-transform duration-300 group-hover:scale-110`}>
          <Icon className="w-5 h-5" />
        </div>
        <h3 className="text-sm font-bold text-gray-500 tracking-wide uppercase">{title}</h3>
      </div>
      <div className="relative z-10">
        <p className="text-3xl font-extrabold text-gray-900 tracking-tight">{(value ?? 0).toLocaleString()}</p>
      </div>
    </div>
  );

  const Section = ({ title, icon: SectionIcon, children }) => (
    <div className="mb-6 last:mb-0">
      <div className="flex items-center gap-2 mb-2 px-1">
        <div className="p-1.5 bg-gray-100 rounded-lg text-gray-600 border border-gray-200">
          <SectionIcon className="w-5 h-5" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 tracking-tight">{title}</h2>
      </div>
      <div className="pl-1 md:pl-10">
        {children}
      </div>
    </div>
  );

  return (
    <div className="flex flex-col mb-0 mt-0">
      <Section title="Traffic" icon={Activity}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {row1.map(StatCard)}
        </div>
      </Section>

      <Section title="Engagement" icon={BarChart2}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {row2.map(StatCard)}
        </div>
      </Section>

      <Section title="Image Search Engagement" icon={ImageIcon}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {row3.map(StatCard)}
        </div>
      </Section>
    </div>
  );
}
